<template>
    <card>
        <card-header class="pb-0">{{ title }}</card-header>
        <card-body class="pt-0" v-if="loading">
            <card-spinner style="min-height: 204px"></card-spinner>
        </card-body>
        <card-body class="py-1" v-if="!loading" style="min-height: 200px">
            <rating-metrics :data="ratings"></rating-metrics>
        </card-body>
    </card>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        props: {
            title: {default: 'Responses Overview'},
            type: {default: 'public'},
            stars: {default: 5},
        },

        data: () => ({
            loading: true,
            ratings: [],
        }),

        computed: {
            ...mapState(['filter']),
        },

        watch: {
            filter() {
                this.fetchRatingsOverview();
            },
        },

        created() {
            this.fetchRatingsOverview().then(() => this.loading = false);
        },

        methods: {
            fetchRatingsOverview() {
                const params = {
                    ...this.filter,
                    type: this.type,
                };
                return this.$http.get(this.$laroute.route('api.reviews.ratings-overview'), {params})
                    .then(response => this.ratings = response.data);
            }
        }
    };
</script>
